module.exports = __webpack_public_path__ + "img/RMR Home Page.78470442.png";